module.exports = __webpack_public_path__ + "static/media/square1.c865cbe3.svg";